/*!
 * Floating Labels
 */
var $ = require('jquery');

$(function() {
	var FL_onClass = 'control-label--on',
			FL_showClass = 'control-label--show';

	// focus/blur via event delegation — works for dynamically created elements
	$(document)
			.on('focus', '.form-group .form-control', function() {
				$(this).closest('.form-group').find('> .control-label').addClass(FL_onClass);
			})
			.on('blur', '.form-group .form-control', function() {
				$(this).closest('.form-group').find('> .control-label').removeClass(FL_onClass);
			});

	var formFloatingLabel = function () {
		$('.form-group--floating-label .form-control')
				.bind('checkval', function() {
					var label = $(this).prev('.control-label');
					if (this.value !== '') {
						label.addClass(FL_showClass);
					} else {
						label.removeClass(FL_showClass);
					}
				})
				.on('keyup', function() {
					$(this).trigger('checkval');
				})
				.on('change', function() {
					$(this).trigger("checkval");
				})
				.trigger('checkval');

		$('.form-group--floating-label-typeahead .form-control')
				.bind('checkval', function() {
					var label = $(this).parent().parent().parent().find('.control-label');
					label.on('click', function() {
						var labelId = $(this).attr('for');
						$('#'+labelId+'_label').trigger('focus');
					});
					if (this.value !== '') {
						label.addClass(FL_showClass);
					} else {
						label.removeClass(FL_showClass);
					}
				})
				.on('keyup', function() {
					$(this).trigger('checkval');
				})
				.on('change', function() {
					$(this).trigger("checkval");
				})
				.trigger('checkval');
	}

	formFloatingLabel();

	$(document).on('afterContentsReplaced', function () {
		formFloatingLabel();
	})

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/formFloatingLabels.js